<script context="module">
    import newUniqueId from 'locally-unique-id-generator'
</script>


<script lang="ts">

    import {myStore} from "../../stores.js";

    export let group;
    export let value;
    export let title;
    export let type;
    /** The key to listen for */
    export let key: string = null;

    export let checked;

    export let disabled;


    let id = newUniqueId();


    function getIcon(value) {
        switch (value) {
            case 'yes':
                return `<svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.0643 2.43414L7.56385 15.022L1.88184 9.30024" stroke="#56B833" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
            case 'no':
                return `<svg width="18" height="18" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 19.3243C15.1944 19.3243 19 15.5188 19 10.8243C19 6.12992 15.1944 2.32434 10.5 2.32434C5.80558 2.32434 2 6.12992 2 10.8243C2 15.5188 5.80558 19.3243 10.5 19.3243Z" stroke="#F64E60" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M4.5498 4.87433L16.4498 16.7743" stroke="#F64E60" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
            // Add more cases as needed
            case 'neutral':
                return `<svg width="21" height="18" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.08545 8.8244H18.9146" stroke="#F3953F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`;
            default:
                return ''; // Default case if needed
        }
    }

    //  export let firstSelected = true;

    //  $: _firstSelected = Number(firstSelected);

    function handleChange(e) {
        //value = Boolean(_firstSelected);
        //$myStore.addField(`communities`,c, communities.length + 1);
        console.log("cast for field " + group + ": ", value);
        console.log("boolean = ", Boolean(value));
        if (value == "1" || value == "0") {

            $myStore.setData(group, (val) => value === "1");

        } else {
            $myStore.setData(group, (val) => value);
        }
    }

</script>

<!--<svelte:window on:keypress={handleKey}/>-->
<span class="radio-btn type-{type}">
    <input type="radio" id="{id}"  disabled={disabled} value="{value}" on:change={handleChange} name="group-{key}" {checked}><!-- name="{group}"-->
    <label for="{id}" class:checked={checked}>
        {#if type}
            <span class="btn-icon">{@html getIcon(type)}</span>
        {/if}
        <span class="radio-title">{title}</span>
    </label>
</span>

<style lang="scss">


  .radio-btn {

    display: inline-flex;
    align-content: center;
    margin-right: 1rem;
    position: relative;
    //height:60px;

    .btn-icon {

      margin-right: 0.7rem;
      height: 20px;

      svg {
        height: 22px;
      }

    }

    .radio-title {
      font-size: 18px;
      min-height: 22px;

    }


    input[type="radio"] {
      opacity: 0;
      position: fixed;
      width: 0;
    }


    label {
      display: flex;
      align-items: center;
      line-height: normal;

      background-color: #ddd;
      padding: 5px 15px;
      font-family: sans-serif, Arial;
      font-size: 16px;
      border: 2px solid transparent;
      border-radius: 7px;
      cursor:pointer;
    }

    input[type="radio"]:checked + label {
      //  background-color: #bfb;
      //  border-color: #4c4;
    }

    input[type="radio"]:checked + label::after {
      content: url("data:image/svg+xml,%3Csvg width='13' height='10' viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 2L4.8125 8L2 5.27273' stroke='%23F8F7F7' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
      position: absolute;
      border-radius: 12px;
      padding: 2px 5px;
      top: -10px;
      right: -10px;
    }

    input[type="radio"]:focus + label {
      //  border: 2px dashed #444;
    }

    label:hover {
      background-color: #dfd;
    }

  }


  .type-yes {
    label {
      color: $success-color;
      background: $success-lighter;
    }

    label:hover {
      background-color: rgb(180, 246, 243, 0.7);
    }

    input[type="radio"]:checked + label {
      border: 4px solid  $success-color;
    }

    input[type="radio"]:checked + label::after {
      background-color: $success-color;
    }

  }

  .type-no {
    label {
      color: $error-color;
      background: $error-lighter;
    }

    label:hover {
      background-color: rgb(251, 175, 183, 0.7);
    }

    input[type="radio"]:checked + label {
      border: 4px solid $error-color;
    }

    input[type="radio"]:checked + label::after {
      background-color: $error-color;
    }
  }

  .type-neutral {
    label {
      color: $warning-color!important;
      background: $warning-lighter;
    }

      label span {
        color: $warning-color!important;
      }


      label:hover {
      background-color: rgb(243, 149, 63, 0.7);
    }

    input[type="radio"]:checked + label {
      border: 4px solid $warning-color;
    }

    input[type="radio"]:checked + label::after {
      background-color: $warning-color;
    }

  }


  /*
      $start-item-offset: 6px;
      label {
          border: 1px solid black;
          border-radius: 12px !important;

          display: flex;
          cursor: pointer;
          margin-left: $start-item-offset;

          &.checked {
              border-width: 2px;
              .start-item {
                  border-width: 2px;
                  background: rgba(248, 185, 44, 1);
              }
          }

          &:focus-within {
              box-shadow: var(--btn-focus-box-shadow);
          }
      }
      input[type="radio"] {
          all: unset;
      }
      .start-item {
          border: 1px solid black;
          border-radius: 5px;
          color: black;

          font-family: 'Open Sans', sans-serif;
          font-size: 12px;
          font-weight: 600;
          //line-height: 12px;
          letter-spacing: 0;
          text-align: left;

          line-height: 1;
          margin: auto 0;
          padding: 8px;
          background-color: white;
          transform: translateX(-$start-item-offset);
      }
      .label-text {
          font-family: 'Open Sans', sans-serif;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.2rem;
          letter-spacing: 0;
          text-align: left;

          color: black;
          padding: 15px 20px 15px 5px;
      }

   */
</style>
